// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"f62c9027","290":"3914a1d5","318":"1db24da5","713":"5e6e7c1b","807":"5246cf97","818":"d3acb3f9","896":"0c391dcd","900":"815301c4","932":"ec42eaf9"}[chunkId] + ".chunk.js";
};